import { render, staticRenderFns } from "./WxWaring.vue?vue&type=template&id=5820eb32&scoped=true&"
import script from "./WxWaring.vue?vue&type=script&lang=js&"
export * from "./WxWaring.vue?vue&type=script&lang=js&"
import style0 from "./WxWaring.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WxWaring.vue?vue&type=style&index=1&lang=css&"
import style2 from "./WxWaring.vue?vue&type=style&index=2&id=5820eb32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820eb32",
  null
  
)

export default component.exports